'use client';
import React from 'react'
import {
    Box,
    Stack,
    Container,
    Link as ChakraLink
} from "@chakra-ui/react"
import { Headline } from '../../-components/Headline';
import { ContactForm } from './Form';
import Link from "next/link"
import { HubspotProvider } from '@aaronhayes/react-use-hubspot-form';

export const ContactComponent = () => {
    return (
        <Box
            as='section'
            position='relative'
            py={{ base: 20, md: 36 }}
        >
            <Container>
                <Stack
                    maxW={{ base: 'full', md: '7xl' }}
                    mx='auto'
                    direction={{ base: 'column', lg: 'row' }}
                    spacing={{ base: '16', lg: '36' }}
                >
                    <Stack spacing='10' color="fg.default" px={{ base: 3, md: 'initial' }}>
                        <Headline
                            heading='Get in touch'
                            textAlign="left"
                            minW={{ base: 'full', md: "sm", lg: "sm", xl: "lg" }}
                            subheading={
                                <Stack spacing={6} fontSize={{ base: 'md', md: "lg" }}>
                                    <Box>
                                        Can't find what you're after?
                                    </Box>
                                    <Box>
                                        Reach out to our friendly support team directly. We will get back to you as soon as possible — generally within one business day at the latest.
                                    </Box>
                                    <Box>
                                        For any media enquiries, please drop us an email over at: <ChakraLink as={Link} href="mailto:media@rarchy.com">media@rarchy.com</ChakraLink>.
                                    </Box>
                                </Stack>
                            }
                        />
                    </Stack>
                    <HubspotProvider>
                        <ContactForm />
                    </HubspotProvider>
                </Stack>
            </Container>
        </Box>
    )
}